import { Box, Container, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import { useT } from '../../i18n';
import { ResidentDownloadButton } from './ResidentDownloadButton';

const BULLETS = ['landing.res.b1', 'landing.res.b2', 'landing.res.b3', 'landing.res.b4', 'landing.res.b5'];

export function ForResidents() {
  const t = useT();

  return (
    <Box component="section" id="warga" sx={{ bgcolor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '0.85fr 1.15fr' },
            gap: { xs: 4, md: 6 },
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              order: { xs: 2, md: 1 },
              minHeight: { xs: 200, md: 300 },
              borderRadius: 3,
              bgcolor: 'action.hover',
              border: 1,
              borderColor: 'divider',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'text.disabled',
              gap: 1,
            }}
          >
            <PhoneIphoneRoundedIcon sx={{ fontSize: 40 }} />
            <Typography variant="caption">{t('landing.res.title')}</Typography>
          </Box>

          <Box sx={{ order: { xs: 1, md: 2 } }}>
            <Typography
              variant="overline"
              sx={{ color: 'secondary.main', fontWeight: 600, letterSpacing: '0.6px' }}
            >
              {t('landing.res.kicker')}
            </Typography>
            <Typography variant="h3" fontWeight={700} sx={{ mt: 1, letterSpacing: '-0.3px' }}>
              {t('landing.res.title')}
            </Typography>
            <List sx={{ mt: 1 }}>
              {BULLETS.map((key) => (
                <ListItem key={key} disableGutters sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 34, color: 'success.main' }}>
                    <CheckRoundedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={t(key)} />
                </ListItem>
              ))}
            </List>
            <Box sx={{ mt: 2 }}>
              <ResidentDownloadButton />
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
